import { useTranslation } from 'react-i18next';
import { AlertTriangle, X } from 'lucide-react';
import { chiaveErroreOnline } from '../../utils/chiave-errore-online';
import './DrawnOpeningBanner.css';

interface AvvisoErroreProps {
  /** Il codice o il messaggio arrivato dal server; `null` se non c'e' niente. */
  errore: string | null;
  onChiudi: () => void;
}

/**
 * L'errore della partita, finalmente a schermo.
 *
 * Lo store scriveva `error` in sei punti diversi — rollback di una mossa
 * rifiutata, offerte respinte, `game:error` — e nessun componente lo leggeva:
 * ogni fallimento era invisibile. Questo e' il lettore che mancava.
 */
export default function AvvisoErrore({ errore, onChiudi }: AvvisoErroreProps) {
  const { t } = useTranslation();
  if (!errore) return null;
  const chiave = chiaveErroreOnline(errore);
  return (
    <div className="drawn-opening-banner" role="alert" data-testid="avviso-errore">
      <span className="dob-icon" aria-hidden="true"><AlertTriangle size={16} /></span>
      <span className="dob-text">
        <span className="dob-label">{t(chiave, 'Something went wrong. Try again.')}</span>
      </span>
      <button type="button" className="dob-close" aria-label={t('common.close', 'Close')} onClick={onChiudi}>
        <X size={14} />
      </button>
    </div>
  );
}
